import images from "./images";

let SkillSet = [
  {
    id: 1,
    name: "C++",
    bgColor: "",
    imageUrl: images.cpp,
  },
  {
    id: 2,
    name: "JavaScript",
    bgColor: "",
    imageUrl: images.javascript,
  },
  {
    id: 3,
    name: "MySQL",
    bgColor: "",
    imageUrl: images.mysql,
  },
  {
    id: 4,
    name: "React Js",
    bgColor: "",
    imageUrl: images.react,
  },
  {
    id: 5,
    name: "Node Js",
    bgColor: "",
    imageUrl: images.node,
  },
  {
    id: 6,
    name: "HTML",
    bgColor: "",
    imageUrl: images.html,
  },
  {
    id: 7,
    name: "CSS",
    bgColor: "",
    imageUrl: images.css,
  },
  {
    id: 8,
    name: "Git",
    bgColor: "",
    imageUrl: images.git,
  },
  {
    id: 9,
    name: "Spring Boot",
    bgColor: "",
    imageUrl: images.springboot,
  },
];

export default SkillSet;
